var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownloadIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 4,
    fill: "#F8D680"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.8955 14.6869H22.7389L17.9998 19.426L13.2607 14.6869H16.1042V9H19.8955V14.6869Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.8501 21.8259C26.6511 21.6136 25.3232 20.1928 24.9441 19.8222C24.6784 19.5675 24.3245 19.4256 23.9564 19.426H22.2911L25.1952 22.2638H21.8362C21.7905 22.263 21.7455 22.2742 21.7055 22.2963C21.6656 22.3184 21.6322 22.3507 21.6087 22.3899L20.8353 24.1651H15.1635L14.3901 22.3899C14.3665 22.3508 14.3331 22.3187 14.2932 22.2966C14.2533 22.2744 14.2083 22.2631 14.1626 22.2638H10.8036L13.7067 19.426H12.0424C11.6661 19.426 11.3069 19.5767 11.0548 19.8222C10.6756 20.1938 9.34773 21.6145 9.14869 21.8259C8.68521 22.3197 8.43024 22.7131 8.55157 23.1993L9.08329 26.1129C9.20461 26.6001 9.73823 27 10.27 27H25.7308C26.2625 27 26.7961 26.6001 26.9174 26.1129L27.4491 23.1993C27.5686 22.7131 27.3146 22.3197 26.8501 21.8259Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadIcon);
export default __webpack_public_path__ + "static/media/downloadIcon.eef86b29c34d324674da025abe9c7bed.svg";
export { ForwardRef as ReactComponent };